<template>
  <v-card>
    <v-card-title class="headline">{{ dialog.Title }}</v-card-title>
    <v-card-text>
      <iframe
        width="100%"
        height="350px"
        :src="dialog.VideoID"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      ></iframe>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>


<script>
export default {
  props: {
      dialog : {
        VideoID: "",
        Title: "",
      },
  },
  watch: {
    dialog: function(value) {
      if (!value) {
        this.dialog.VideoID = "";
        this.dialog.Title = "";
        this.dialog.Open = false;
      }
    },
  }
};
</script>